module.exports = __webpack_public_path__ + "static/EvilIcons-140c53a7643ea949007aa9a282153849.ttf";